module.exports = __webpack_public_path__ + "media/components/Cards/images/metal-silver-card-26610a3cc9773d53b7dda1c563b5237f.png";